import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SocialLinks } from '../../shared/social-links/social-links';
import { ScrollToSectionDirective } from '../../shared/scroll-to-section.directive';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, SocialLinks, ScrollToSectionDirective],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly router = inject(Router);

  protected readonly currentYear = new Date().getFullYear();

  protected onLogoClick(event: Event): void {
    if (this.router.url === '/') {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
